import Api from './api';
import './main_menu.sass';
import LoginForm from './login_form.vue';
import {createPageAt} from './page-common';
import * as VueRouter from 'vue-router';

try {
    var el = document.getElementById('auth-form');
    if (el) {
        const routes = [];
        const router = VueRouter.createRouter({
            history: VueRouter.createWebHistory(),
            routes,
        });
        createPageAt(el, LoginForm, null, app => {
            app.use(router);
        });
    } else {
        console.debug("Cannot find auth form element!");
    }
}catch(e) {
    console.error("Failed to create login form", e);
}

window.fbAsyncInit = function () {
    FB.init({
        appId: '1152558645098184',
        cookie: true,
        xfbml: true,
        version: 'v7.0'
    });
};

function tryRedirect() {
    const search = !location.search
        ? {} 
        : location.search.substring(1).split('&').map(c => c.split('=')).reduce((a, b) => { a[b[0]] = (b.length > 1 ? b[1] : true); return a; }, {});
    if (search["redirect"]) {
        location.href = decodeURIComponent(search["redirect"]);
    } else if (search["returnUrl"]) {
        location.href = decodeURIComponent(search["returnUrl"]);
    } else {
        if (document.location.pathname == "/mapp/login")
            document.location = "/"; // login page without redirect/returnUrl
        else if (document.location.pathname == "/mapp/register")
            document.location = "/"; // register page without redirect/returnUrl
        else {
            document.location.reload();
        }
    }
}

window.onSignedInFacebook = async response => {
    await Api.authFacebook(response.authResponse.accessToken);
    tryRedirect();
};

window.onSignedInGoogle = async response => {
    const authResult = await Api.authGoogle(response.credential);
    if (authResult.success === false) {
        return;
    }
    tryRedirect();
};


let linkLoginNameLinks = document.getElementsByClassName('linkLoginName');
let linkLoginPanel = document.getElementById('linkLoginPanel');
for (var i = 0; i < linkLoginNameLinks.length; ++i) {	
    linkLoginNameLinks[i].onclick = e => {
        e.preventDefault();
        if (window.authenticated) {
            if (linkLoginPanel.style.display === 'block') {
                linkLoginPanel.style.display = 'none';
            } else {
                linkLoginPanel.style.display = 'block';
                let y = linkLoginNameLinks.offsetLeft + linkLoginNameLinks.offsetWidth;
                //linkLoginPanel.style.left = (y - linkLoginPanel.clientWidth) + 'px';
                linkLoginPanel.style.right = '4px';
            }
        } else {
            window.auth();
        }
    };
}

async function signout() {
    await Api.logout();
}
window.signout = signout;

let cmdLogout = document.getElementById('cmdLogout');
if (cmdLogout) {
    cmdLogout.onclick = async e => {
        e.preventDefault();
        await signout();        
        document.location.reload();
    };
}

let cmdSignInCancel = document.getElementById('cmdSignInCancel');
if (cmdSignInCancel) {
    cmdSignInCancel.onclick = () => {
        let signInForm = document.getElementById('sign-in-form');
        signInForm.style.display = 'none';
    };
}

let signInOverlay = document.getElementById('sign-in-overlay');
if (signInOverlay) {
    signInOverlay.onclick = () => {
        let signInForm = document.getElementById('sign-in-form');
        signInForm.style.display = 'none';
    };
}

window.redirectToLogin = () => {
    localStorage.setItem("return_url", location.href);
    location.href = "/mapp/login";
};

window.rememberReturnUrl = () => {
    localStorage.setItem("return_url", location.href);
};

window.auth = () => {
    let signInForm = document.getElementById('sign-in-form');
    window.rememberReturnUrl();
    signInForm.style.display = 'block';
}

if (!window.authenticated) {
    document.addEventListener('mousedown', e => {
        let require = e.target.classList.contains("authorize");
        if (!require && e.target.parentElement)
            require = e.target.parentElement.classList.contains("authorize");
        if (!require && e.target.parentElement && e.target.parentElement.parentElement)
            require = e.target.parentElement.parentElement.classList.contains("authorize");
        if (require) {
            e.preventDefault();
            e.stopPropagation();
            window.auth();
        }
    }, true);
}
/*
let authenticationForm = document.getElementById('authentication-form');
if (authenticationForm) {
    authenticationForm.onsubmit = async e => {
        e.preventDefault();
        var email = authenticationForm.querySelector('.email');
        var password = authenticationForm.querySelector('.password');
        let response = await Api.auth(email, password);
        if (response && response.ok) {
            document.reload();
        } else {

        }
    }
}*/

Api.stat();